const reducers = {
  setVenue(state, action) {
    const { venue } = action.payload;
    state.venue = venue;
    state.venueLookupFailed = false;
  },
  setVenueLookupFailed(state, action) {
    const { venueLookupFailed } = action.payload;
    state.venueLookupFailed = venueLookupFailed;
  },
  setSubmission(state, action) {
    const { userWon, prize } = action.payload;
    state.userWon = userWon;
    state.prize = prize;
  },
  setJoke(state, action) {
    const { joke } = action.payload;
    state.joke = {...joke};
  }
};

export default reducers;